<!--Copy right - © 2024 tecera gmbh-->
<script>
    import {
        is_authenticated,
        check_if_authenticated,
        user_role,
        rerout_user,
    } from "../scripts/auth.js";
    import NavBar from "../components/NavBar.svelte";
    import Footer from "../components/Footer.svelte";
    import NutzerTabelle from "../components/NutzerTabelle.svelte";
    import { selected_device, user_list, toast_message } from "../stores.js";
    import { BASE_API_URL } from "../config.js";
    import { onMount, tick } from "svelte";
    import { get_user_list,get_customer_list} from "../scripts/data.js";
    import KundenAnlegen from "../components/KundenAnlegen.svelte";

    onMount(async () => {
        $selected_device = null; // need to set this to null incase user comes from different tab
        await check_if_authenticated(); // waiting for auth before proceeding
        if (
            !$user_role["view_settings_user"] ||
            $user_role["view_settings_user"] != 1
        ) {
            rerout_user();
            return;
        }
        get_user_list();
        get_customer_list();
    });

    $: user_list_copy = JSON.parse(JSON.stringify($user_list)); // deep copy of user_list so we can use save/reset functionality

    async function check_table_overflow() {
        // check wether the table gets a scrollbar, so dropdowns are not cut off
        await tick();
        if (user_box && user_box.scrollHeight > user_box.clientHeight) {
            user_box.style.overflow = "auto";
        } else if (user_box) {
            user_box.style.overflow = "visible";
        }
    }

    $: {
        // check overflow on table changes
        if (user_list_copy) {
            check_table_overflow();
        }
    }

    function reset_user_list_copy() {
        // reset user_list_copy to original state
        user_list_copy = JSON.parse(JSON.stringify($user_list));
    }

    async function save_user_list() {
        timeout_button();
        // save changes and make the API call
        function get_changed_entries() {
            // determine changed entries, to not send all data every time
            const changed_entries = [];

            for (let i = 0; i < $user_list.length; i++) {
                if (user_list_copy[i] === null) {
                    changed_entries.push({
                        is_deleted: true,
                        user_data: {
                            id: $user_list[i].id,
                        },
                    });
                } else if (
                    JSON.stringify($user_list[i]) !==
                    JSON.stringify(user_list_copy[i])
                ) {
                    changed_entries.push({
                        user_data: {
                            id: user_list_copy[i].id,
                            mapview_role: user_list_copy[i].role.id,
                        },
                        permissions_data: {
                            // access_hymo:
                            //     user_list_copy[i].permissions.access_hymo,
                            // access_water_meter:
                            //     user_list_copy[i].permissions
                            //         .access_water_meter,
                            access_drinking_fountains:
                                user_list_copy[i].permissions
                                    .access_drinking_fountains,
                        },
                    });
                }
            }

            return changed_entries;
        }
        let changed_entries = get_changed_entries();
        let url_extension = `/users/bulk-update/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(changed_entries),
            });
            if (!response.ok) {
                return false;
            }
            $toast_message = " Änderungen gespeichert.";
            get_user_list();
            return true;
        } catch (error) {
            return false;
        }
    }

    let user_box;
    let is_button_disabled = false;
    function timeout_button() {
        is_button_disabled = true;
        setTimeout(() => {
            is_button_disabled = false;
        }, 500);
    }
</script>

<svelte:head>
    <title>myBach | Verwaltung</title>
</svelte:head>

{#if $is_authenticated && $user_role["view_settings_user"] == 1}
    <div class="container-fluid">
        <div class="row">
            <!-- Main Content -->
            <main class="col-12 ml-sm-auto px-md-4">
                <NavBar headline="Nutzerverwaltung" />

                <div class="row">
                    <!-- Linke Seite -->
                    <div
                        class="col-12 col-lg-8 col-xl-9 content_main"
                        style="display:flex;flex-direction:column;justify-content:flex-start;"
                    >
                        <!-- Tabelle -->
                        <div
                            class="row mt-4"
                            style="flex: 1 1 40%;overflow:hidden;"
                        >
                            <div class="col-12 full">
                                <div
                                    class="user_box2"
                                    style="overflow:auto;"
                                    bind:this={user_box}
                                >
                                    <NutzerTabelle user_list={user_list_copy} />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" style="flex: 0 0 4%;">
                            <!-- Buttons -->
                            <div class="btn-toolbar-inverse pb-1 ml-auto">
                                <div class="btn-distance">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        on:click={() => reset_user_list_copy()}
                                        >Zurücksetzen</button
                                    >
                                </div>

                                <div class="btn-distance">
                                    <button
                                        class="btn btn-primary"
                                        type="button"
                                        disabled={is_button_disabled}
                                        on:click={() => {
                                            save_user_list();
                                        }}>Änderungen speichern</button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-12 col-lg-4 col-xl-3 content_main content_main_side"
                    >
                        <div class="row pt-4 full">
                            <div class="col-12 full">
                                <div class="display_box side-menu">
                                    <p class="p-kachel">Kundengruppen</p>
                                    <KundenAnlegen />
                                    <!-- <EmailAnlegen /> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
    <Footer />
{/if}
